import { BaseService } from "./BaseService";

export const EmpenhoService = {
    async index(filter = null) {
        try {
            return await BaseService.fetchResponseFromAPIPost('empenhos/search', filter);
        } catch (error) {
            console.error('Ocorreu um erro ao listar todas as empenhos:', error);
            return false;
        }
    },
    async destroy(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('empenhos/destroy', postData);
        } catch (error) {
            console.error('Ocorreu um erro ao excluir empenhos(s):', error);
            return false;
        }
    }, 
    async show(id) {
        try {
            return await BaseService.fetchResponseFromAPIGet(`empenhos/${id}`);
        } catch (error) {
            console.error('Ocorreu um erro durante a busca de processos de empenhos:', error);
            return false;
        }
    }, 
    async history(id) {
        try {
            return await BaseService.fetchResponseFromAPIGet(`empenhos/historico/${id}`);
        } catch (error) {
            console.error('Ocorreu um erro ao buscar o histórico de compras:', error);
            return false;
        }
    }
}